/* eslint-disable */
;(function () {
  'use strict';

  const secondsPerSlide = 7;  // Keep in sync with transition duration in sass/components/_image-text-slider.scss

  function setupAutoSlider(slider) {
    let dots = Array.from(slider.querySelectorAll('.image-text-slider__dot'));
    let arrows = Array.from(slider.querySelectorAll('.image-text-slider__arrow'));
    let lastDot = undefined;
    let preventCancel = false;

    let turn = () => {
      const dot = dots.shift();
      dots.push(dot);
      preventCancel = true;
      dot.click();
      preventCancel = false;
      if (lastDot) {
        lastDot.classList.remove('image-text-slider__dot--animated');
      }
      dot.classList.add('image-text-slider__dot--animated');
      lastDot = dot;
    };

    let intervalId = setInterval(turn, secondsPerSlide * 1000);
    turn();


    [...dots, ...arrows].forEach(element => {
      element.addEventListener('click', () => {
        if (!preventCancel) {
          dots.forEach(dot => dot.classList.remove('image-text-slider__dot--animated'));
          clearInterval(intervalId);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('.css-slider--auto-slide'),
      setupAutoSlider
    );
  });
}());
